import CtrlDisponibilidadePage from './pages/CtrlDisponibilidadePage.vue'
import ProvedoresDisponibilidadePage from './pages/ProvedoresDisponibilidadePage.vue'

const routes = [
  {
    path: 'ctrl-disponibilidade',
    name: 'ctrl-disponibilidade',
    component: CtrlDisponibilidadePage
  },
  {
    path: 'ctrl-disponibilidade/:disponibilidade/provedores',
    name: 'provedores-disponibilidade',
    component: ProvedoresDisponibilidadePage
  }
];

export default routes;

